<template>
    <div :class="{ 'cpt-iconfont': true, 'cpt-iconfont-fixed': isFiexd }" :style="{
        ...styleComputed,
        ...fiexdStyleComputed,
        // ...fiexdStyles
    }" @click="onClickHandler">
        <div @click="onClickHandler" :class="`iconfont icon-${iconComputed}`"></div>
    </div>

</template>

<script setup>
import { computed, defineProps, onMounted, ref, defineEmits } from 'vue'
const emit = defineEmits(['clickHandler'])
const props = defineProps({
    option: Object,
    height: Number,
    current: Object,
    cacheComponents: Array,
    components: Array,
    refMap: Object,
    scale: Number,
})
let combination = ref('')
let isFiexd = ref(false)
const isDesign = ref(location.href.includes('/design'))

const iconComputed = computed(() => {
    console.log(props, 'iconComputediconComputed')
    let icon = props.option?.attribute?.iconfont?.font_class

    return icon ? icon : 'morentubiao'
})
const styleComputed = computed(() => {
    // console.log(props.option?.attribute, 'attributeattributeattribute')
    let style = {
        '---color': props.option?.attribute?.color,
        '---fontSize': props.option?.attribute?.fontSize + 'px',
        'z-Index': props.component ? props.component.length + 1 : 100,
    }
    if (combination.value && combination.value.tabIndex >= 0) {
        try {
            const { attribute, cptDataForm } = combination.value.cptOption
            let { textColor, activeColor } = attribute
            let { tabGroupValue } = props.current.cptOption.attribute
            let tabDataList = JSON.parse(cptDataForm.dataText)
            let tabValue = tabDataList.options[combination.value.tabIndex].value

            let itemActiveColor = tabGroupValue == tabValue ? activeColor : textColor
            style['---color'] = itemActiveColor
            style['cursor'] = 'pointer'
        } catch (error) {
            console.error('图标样式设置失败:', error)
        }
    }
    console.log(style, 'aijsdisajid9adji9adisa')
    return style
})
const fiexdStyleComputed = computed(() => {
    let style = {}
    if (isFiexd.value) {
        let position = (combination.value && combination.value.cptOption.attribute.position)
        let topY = (props.current.cptY - combination.value.cptY)
        let bottomY = (props.current.cptY - combination.value.cptY) + (props.current.cptHeight / 2)
        let { postitionY, postitionX } = combination.value.cptOption.attribute
        if (position == 'all') {
            style['top'] = (postitionY ? (postitionY + topY) : props.current.cptY) + 'px'
        } else {
            if (postitionY) {
                style[position] = (position === 'bottom' ? postitionY + bottomY : postitionY + topY) + 'px'
            } else {
                style[position] = (position === 'bottom' ? bottomY : topY) + 'px'
            }
        }
        if (postitionX) {
            let x = props.current.cptX - combination.value.cptX
            style['left'] = (postitionX + x) + 'px'
        } else {
            // style['left'] = (props.current.cptX * props.scale?.containerScaleX) + 'px'

            // style['left'] = (combination.value.cptX + (props.current.cptX ) - combination.value.cptX)  + 'px'
            // style['left'] = (combination.value.cptX + (props.current.cptX ) - combination.value.cptX)  + 'px'
            style['left'] = ((props.current.cptX - combination.value.cptX) * props.scale.containerScaleX) + combination.value.cptX + 'px';
        }
        style['width'] = props.current.cptWidth + 'px'
        style['height'] = props.current.cptHeight + 'px'
    }

    return style
})
const setIsFiexd = () => {


    // 是否是关联组合选项卡
    const isTabGroupId = props.option.attribute.isTabGroupId
    const tab = props.components ? props.components : props.cacheComponents
    combination.value = tab.find(item => item?.cptType === 'combination' && isTabGroupId === item.id)
    console.log(combination.value, 'combination.valuevaluevaluevaluevalue')

    if (isDesign.value) {
        return false
    }
    if (!combination.value) {
        return false
    }
    // 是否是悬浮选项卡
    const combinationIsFiexd = combination.value.cptOption.attribute.isFiexd

    isFiexd.value = isTabGroupId && combinationIsFiexd

}

const onClickHandler = () => {
    const { tabGroupValue, isTabGroupId, tabIndex } = props.current.cptOption.attribute
    if (isTabGroupId) {
        let tab = props.refMap[isTabGroupId]
        if (!tab) {
            return console.log('tab不存在')
        }
        let tabFindIndex = tab.tabs.findIndex(x => x.value == tabGroupValue)
        if (tabFindIndex == -1) {
            props.current.cptOption.attribute.tabGroupValue = tab.tabs[tabIndex].value
            tab.changeTab(tab.tabs[tabIndex].value, tabIndex)
        } else {
            tab.changeTab(tabGroupValue, tabFindIndex)
        }
        console.log(tabGroupValue, tabIndex, tab, props.current.cptOption, 'asdokjasio0asdjidisjdi')
    } else {
        emit("clickHandler", props.option.interaction, 'default', '', 'cpt-iconfont')
    }
}


onMounted(() => {
    setIsFiexd()
    // getTabMessage()
})


</script>

<style>
.cpt-iconfont {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.cpt-iconfont-fixed {
    position: fixed;
    width: unset;
    height: unset;
    top: var(---top);
    left: var(---left);

}

.cpt-iconfont .icon {
    width: 100%;
    height: 100%;
    vertical-align: -0.15em;
    overflow: hidden;
}

.iconfont {
    color: var(---color);
    font-size: var(---fontSize);
}
</style>